// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ig","input":"ih","button":"ii"};